import { graphql } from '@/lib/graphql';

export const VoicemailsSubscription = graphql(`
  subscription Voicemails($where: VoicemailsBoolExp!, $limit: Int!, $offset: Int!) {
    voicemails(where: $where, orderBy: { createdAt: DESC }, limit: $limit, offset: $offset) {
      id
      fromNumber
      toNumber
      durationSeconds
      status
      createdAt
      s3Key
      recordingUrl
      publicRecordingUrl
      flow {
        id
        name
      }
      phoneNumber {
        id
        friendlyName
        phoneNumber
      }
    }
  }
`);

export const VoicemailsCountSubscription = graphql(`
  subscription VoicemailsCount($where: VoicemailsBoolExp!) {
    voicemailsAggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`);

export const UpdateVoicemailStatusMutation = graphql(`
  mutation UpdateVoicemailStatus($id: Uuid!, $status: String!) {
    updateVoicemailsByPk(pkColumns: { id: $id }, _set: { status: $status }) {
      id
      status
    }
  }
`);
